(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_cpd-brewing-method"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var FORM_SELECTOR = 'form[data-type="add-to-cart-form"]';
    var INPUT_ID = 'brewing-method-input';

    function getBlock() {
      return document.querySelector('.cpd-brewing-method');
    }

    /* Step 2a - ensure the hidden line item property input exists in the form.
       The form survives Horizon's variant morph, so this only creates once. */
    function ensureInput() {
      var form = document.querySelector(FORM_SELECTOR);
      if (!form) return null;
      var input = form.querySelector('#' + INPUT_ID);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Méthode]';
        input.id = INPUT_ID;
        input.value = '';
        /* Start disabled; updateVisibility() enables it only when a method
           is actually chosen, so an empty property is never POSTed. */
        input.disabled = true;
        form.appendChild(input);
      }
      return input;
    }

    /* The theme has no data-option-name attribute; the option name is the
       prefix of each radio's name (e.g. "Mouture-<blockid>-<productid>"). */
    function hasMoutureOption() {
      return !!document.querySelector('.variant-picker__form input[name^="Mouture-"]');
    }

    function isMoulu() {
      var checked = document.querySelector('.variant-picker__form input[name^="Mouture-"]:checked');
      if (!checked) return false;
      return checked.value.toLowerCase().indexOf('moulu') !== -1;
    }

    function getSelectedMethod(block) {
      var sel = block.querySelector('.cpd-brewing-method__pill.is-selected');
      if (sel) return sel.getAttribute('data-method');
      var def = block.querySelector('.cpd-brewing-method__pill[data-default]');
      if (def) return def.getAttribute('data-method');
      var first = block.querySelector('.cpd-brewing-method__pill');
      return first ? first.getAttribute('data-method') : '';
    }

    /* Step 2b / 2d / 2e - recompute visibility + the hidden input value. */
    function updateVisibility() {
      var block = getBlock();
      if (!block) return;
      var input = ensureInput();
      var showOnlyMoulu = block.getAttribute('data-show-only-moulu') !== 'false';

      var shouldShow;
      if (!showOnlyMoulu) {
        shouldShow = true;
      } else if (!hasMoutureOption()) {
        shouldShow = false;
      } else {
        shouldShow = isMoulu();
      }

      if (shouldShow) {
        block.setAttribute('data-hidden', 'false');
        if (input) {
          input.disabled = false;
          input.value = getSelectedMethod(block);
        }
      } else {
        block.setAttribute('data-hidden', 'true');
        /* Empty AND disabled, so the property is omitted from the cart POST
           entirely (truly "not set") instead of being stored as an empty
           string, which would otherwise show as a blank "Méthode:" line in
           the Shopify admin order / packing slip. The input stays in the DOM
           (not deleted) so it is reused when Moulu is reselected. */
        if (input) {
          input.value = '';
          input.disabled = true;
        }
      }
    }

    /* Step 2c - method pill click handlers. */
    function bindPills(block) {
      var pills = block.querySelectorAll('.cpd-brewing-method__pill');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) {
            p.classList.remove('is-selected');
            p.setAttribute('aria-pressed', 'false');
          });
          pill.classList.add('is-selected');
          pill.setAttribute('aria-pressed', 'true');

          var input = ensureInput();
          if (input && block.getAttribute('data-hidden') !== 'true') {
            input.value = pill.getAttribute('data-method');
          }
        });
      });
    }

    function init() {
      var block = getBlock();
      if (!block) return; /* block disabled in the editor or not present */

      if (block.dataset.cpdBrewingInit) {
        updateVisibility();
        return;
      }
      block.dataset.cpdBrewingInit = 'true';

      ensureInput();
      bindPills(block);
      updateVisibility(); /* Step 2d - initial state on load */

      /* Primary: Horizon's own variant morph event. The block DOM and the
         injected input both survive the morph, so we only recompute. */
      document.addEventListener('variant:update', function () {
        updateVisibility();
      });

      /* Documented fallback: the bubbling change event from the picker form. */
      var variantForm = document.querySelector('.variant-picker__form');
      if (variantForm) {
        variantForm.addEventListener('change', function () {
          updateVisibility();
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_cpd-purchase-type"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    /* ============================================================
     * TASK 2 - Subscription toggle wired to Shopify selling plans
     * ============================================================ */
    function initCpdPurchase() {
      document.querySelectorAll('[data-cpd-purchase]').forEach(function (container) {
        if (container.dataset.cpdInit) return;
        container.dataset.cpdInit = 'true';

        var hasPlans = container.dataset.hasPlans === 'true';
        if (!hasPlans) return;

        var tabBtns    = container.querySelectorAll('[data-cpd-tab]');
        var plansEl    = container.querySelector('[data-cpd-plans]');
        var planLabels = container.querySelectorAll('[data-cpd-plan-label]');
        var planRadios = container.querySelectorAll('input[data-plan-id]');

        /* Read plan + variant price data from embedded JSON */
        var dataEl = container.querySelector('[data-cpd-plans-json]');
        var plansData = null;
        if (dataEl) {
          try { plansData = JSON.parse(dataEl.textContent); } catch (e) {}
        }

        /* Inject hidden selling_plan input into the product form */
        var productForm = document.querySelector('form[data-type="add-to-cart-form"]');
        var sellingPlanInput = null;
        if (productForm) {
          sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
          if (!sellingPlanInput) {
            sellingPlanInput = document.createElement('input');
            sellingPlanInput.type  = 'hidden';
            sellingPlanInput.name  = 'selling_plan';
            sellingPlanInput.id    = 'cpd-selling-plan-input';
            sellingPlanInput.value = '';
            productForm.appendChild(sellingPlanInput);
          }
        }

        var activeTab = 'one-time';

        /* Tab switching */
        tabBtns.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var tab = btn.dataset.cpdTab;
            if (tab === activeTab) return;
            activeTab = tab;

            tabBtns.forEach(function (b) {
              var on = b.dataset.cpdTab === tab;
              b.classList.toggle('cpd-purchase__tab--active', on);
              b.setAttribute('aria-pressed', on ? 'true' : 'false');
            });

            if (tab === 'one-time') {
              if (plansEl) plansEl.classList.remove('cpd-purchase__plans--open');
              if (sellingPlanInput) sellingPlanInput.value = '';
            } else {
              if (plansEl) plansEl.classList.add('cpd-purchase__plans--open');
              var checked = container.querySelector('input[data-plan-id]:checked');
              if (checked && sellingPlanInput) {
                sellingPlanInput.value = checked.value;
              }
            }
          });
        });

        /* Plan radio selection */
        planRadios.forEach(function (radio) {
          radio.addEventListener('change', function () {
            if (sellingPlanInput) sellingPlanInput.value = radio.value;
            planLabels.forEach(function (lbl) {
              var r = lbl.querySelector('input[data-plan-id]');
              lbl.classList.toggle('cpd-purchase__plan--selected', !!(r && r.checked));
            });
          });
        });

        /* Update plan prices when the selected variant changes */
        function updatePlanPrices(variantId) {
          if (!plansData) return;
          var variantData = null;
          for (var i = 0; i < plansData.variants.length; i++) {
            if (plansData.variants[i].id === variantId) {
              variantData = plansData.variants[i];
              break;
            }
          }
          if (!variantData) return;

          plansData.plans.forEach(function (plan) {
            var alloc = null;
            for (var j = 0; j < variantData.allocations.length; j++) {
              if (variantData.allocations[j].planId === plan.id) {
                alloc = variantData.allocations[j];
                break;
              }
            }
            if (!alloc) return;
            var priceEl = container.querySelector('[data-cpd-plan-price="' + plan.id + '"]');
            if (priceEl) priceEl.textContent = formatMoney(alloc.price);
          });
        }

        function formatMoney(cents) {
          var amount = (cents / 100).toFixed(2).replace('.', ',');
          return '€' + amount;
        }

        /* Listen for variant picker changes */
        var variantForm = document.querySelector('.variant-picker__form');
        if (variantForm) {
          variantForm.addEventListener('change', function () {
            setTimeout(function () {
              var pf = document.querySelector('form[data-type="add-to-cart-form"]');
              if (!pf) return;
              var idInput = pf.querySelector('input[name="id"]');
              if (!idInput) return;
              var vid = parseInt(idInput.value, 10);
              if (vid) updatePlanPrices(vid);
            }, 80);
          });
        }
      });
    }

    /* ============================================================
     * TASK 4 - Gallery inset thumbnail (Bongoo-style)
     * Reads product media + variant data from embedded JSON.
     * Injects a small overlay image into the main product-media
     * container. Swaps src when the Mouture variant changes:
     *   Grain  -> coffee-beans.jpg (fallback) or variant media
     *   Moulu  -> coffee-ground.jpg (fallback) or variant media
     * No-ops if product has neither 2+ images nor a Mouture option.
     * ============================================================ */
    function initCpdGallery(retried) {
      if (document.querySelector('.cpd-media-inset')) return; /* already injected */

      var dataEl = document.querySelector('[data-cpd-gallery-json]');
      if (!dataEl) return;

      var galleryData;
      try { galleryData = JSON.parse(dataEl.textContent); } catch (e) { return; }

      /* Find mouture option index */
      var moutureIdx = -1;
      var opts = galleryData.options || [];
      for (var i = 0; i < opts.length; i++) {
        if (opts[i].toLowerCase().indexOf('mouture') !== -1) {
          moutureIdx = i;
          break;
        }
      }

      var hasMoutureOption  = moutureIdx >= 0;
      var hasMultipleMedia  = galleryData.mediaCount >= 2;
      if (!hasMoutureOption && !hasMultipleMedia) return; /* nothing to show */

      /* Find main image container — pick the one with the largest rendered area.
         Horizon's --tallest element is an invisible spacer (0×0); the actual
         visible container is a plain .product-media-container sibling. */
      var mainContainer = null;
      var maxMcArea = 0;
      var mcEls = document.querySelectorAll('.product-media-container');
      for (var mci = 0; mci < mcEls.length; mci++) {
        /* skip BEM modifier elements like __zoom-button */
        if (mcEls[mci].className.indexOf('product-media-container__') !== -1) continue;
        var mcR = mcEls[mci].getBoundingClientRect();
        var mcArea = mcR.width * mcR.height;
        if (mcArea > maxMcArea) { maxMcArea = mcArea; mainContainer = mcEls[mci]; }
      }
      /* If layout isn't computed yet (all zero), defer once — then give up */
      if (!mainContainer || maxMcArea === 0) {
        if (!retried) setTimeout(function () { initCpdGallery(true); }, 150);
        return;
      }

      /* Initial inset src — use beans as safe default */
      var initialSrc = hasMultipleMedia ? galleryData.media[1].src : galleryData.beansAsset;
      if (!initialSrc) return;

      /* Build inset DOM */
      var inset = document.createElement('div');
      inset.className = 'cpd-media-inset';
      inset.setAttribute('aria-hidden', 'true');
      var insetImg = document.createElement('img');
      insetImg.className = 'cpd-media-inset__img';
      insetImg.src = initialSrc;
      insetImg.alt = '';
      insetImg.loading = 'lazy';
      inset.appendChild(insetImg);
      /* Append to the largest visible .product-media element.
         Same area-based selection as for the container — Horizon's
         --tallest spacer sibling is 0×0 and must be skipped. */
      var pmEls = document.querySelectorAll('.product-media');
      var bestPm = null, bestPmArea = 0;
      for (var pmi = 0; pmi < pmEls.length; pmi++) {
        var pmR = pmEls[pmi].getBoundingClientRect();
        var pmArea = pmR.width * pmR.height;
        if (pmArea > bestPmArea) { bestPmArea = pmArea; bestPm = pmEls[pmi]; }
      }
      var mediaEl = (bestPm && bestPmArea > 0) ? bestPm : mainContainer;
      mediaEl.appendChild(inset);

      /* With object-fit: contain, the product image may be letterboxed inside the
         container. Compute actual rendered content bounds and offset the inset so
         it lands 16px inside the visible photo corner, not the container corner.

         Reposition reactively because the inputs change at multiple moments:
           - initial image decode (load event)
           - image src swap on variant change (load fires again — no { once: true })
           - container resize (window resize, parent layout settling)
           - any aspect-ratio change once the new natural dimensions are available
         A ResizeObserver on both the container and the main image handles the
         layout-settling and aspect-change cases without polling. */
      (function () {
        var mainImg = mediaEl.querySelector('img:not(.cpd-media-inset__img)');
        if (!mainImg) return;
        function positionOverImage() {
          var nw = mainImg.naturalWidth;
          var nh = mainImg.naturalHeight;
          var box = mediaEl.getBoundingClientRect();
          var cw = box.width;
          var ch = box.height;
          if (!nw || !nh || !cw || !ch) return;
          /* Read the actual object-fit on the main image — the theme may use
             either 'contain' (letterboxed) or 'cover' (fills container, cropped).
             With 'cover' or 'fill' there is no letterbox, so the inset hugs
             the container edge directly. With 'contain' we compensate so it
             sits 16px inside the actual visible photo edges, not in the bg. */
          var fit = '';
          try { fit = getComputedStyle(mainImg).objectFit || ''; } catch (e) {}
          var lx = 0, ly = 0;
          if (fit === 'contain' || fit === 'scale-down') {
            var scale = Math.min(cw / nw, ch / nh);
            var imgW  = nw * scale;
            var imgH  = nh * scale;
            lx = Math.max(0, (cw - imgW) / 2);
            ly = Math.max(0, (ch - imgH) / 2);
          }
          /* cover / fill / none: no letterbox to compensate for, lx=ly=0 */
          inset.style.right  = Math.round(lx + 16) + 'px';
          inset.style.bottom = Math.round(ly + 16) + 'px';
        }
        /* Run as soon as we can */
        if (mainImg.complete && mainImg.naturalWidth) {
          positionOverImage();
        }
        /* Re-fire on every subsequent load (variant src swap, retry, etc.) */
        mainImg.addEventListener('load', positionOverImage);
        /* Layout-settling safety net for first paint */
        requestAnimationFrame(positionOverImage);
        setTimeout(positionOverImage, 600);
        /* Window resize: viewport width changes letterbox geometry */
        window.addEventListener('resize', positionOverImage);
        /* Container/image resize: covers aspect-ratio change once new
           dimensions land, and the case where the parent container resizes
           after our initial measurement (e.g., sticky details settling). */
        if (typeof ResizeObserver === 'function') {
          var ro = new ResizeObserver(positionOverImage);
          ro.observe(mediaEl);
          ro.observe(mainImg);
        }
      })();

      /* Horizon navigates to ?variant=ID on each variant click (full page reload).
         Read the selected variant from the product form to set the correct initial image,
         and decide whether to animate based on whether the Mouture option changed. */
      var initForm  = document.querySelector('form[data-type="add-to-cart-form"]');
      var initInput = initForm ? initForm.querySelector('input[name="id"]') : null;
      var currentMouture = '';

      if (initInput) {
        var initVid = parseInt(initInput.value, 10);
        if (initVid) {
          /* Find the selected variant to extract its Mouture value */
          for (var ivi = 0; ivi < galleryData.variants.length; ivi++) {
            if (galleryData.variants[ivi].id === initVid) {
              if (moutureIdx >= 0) {
                currentMouture = (galleryData.variants[ivi].options[moutureIdx] || '').toLowerCase();
              }
              break;
            }
          }
          updateInset(initVid);
        }
      }

      /* Only animate the inset when the Mouture option changed (not on weight-only changes) */
      var prevMouture = '';
      try { prevMouture = sessionStorage.getItem('cpd-mouture') || ''; } catch (e) {}
      if (currentMouture !== prevMouture) {
        inset.classList.add('cpd-media-inset--animate');
      }
      try { sessionStorage.setItem('cpd-mouture', currentMouture); } catch (e) {}

      /* Crossfade helper — preloads newSrc then swaps with a fade */
      function setInsetSrc(newSrc) {
        if (!newSrc || newSrc === insetImg.src) return;
        insetImg.style.opacity = '0';
        var preload = new Image();
        preload.onload = function () {
          insetImg.src = newSrc;
          insetImg.style.opacity = '1';
        };
        preload.onerror = function () {
          /* fall back silently — keep current image */
          insetImg.style.opacity = '1';
        };
        preload.src = newSrc;
      }

      /* Update inset src when variant changes */
      function updateInset(variantId) {
        var variantData = null;
        for (var vi = 0; vi < galleryData.variants.length; vi++) {
          if (galleryData.variants[vi].id === variantId) {
            variantData = galleryData.variants[vi];
            break;
          }
        }
        if (!variantData) return;

        /* Priority 1: variant has a featured media in product.media */
        if (variantData.featuredMediaId) {
          for (var mi = 0; mi < galleryData.media.length; mi++) {
            if (galleryData.media[mi].id === variantData.featuredMediaId) {
              setInsetSrc(galleryData.media[mi].src);
              return;
            }
          }
        }

        /* Priority 2: mouture option value -> fallback asset */
        if (moutureIdx >= 0 && variantData.options) {
          var mVal = (variantData.options[moutureIdx] || '').toLowerCase().trim();
          if (mVal === 'grain' || mVal === 'grains') {
            setInsetSrc(galleryData.beansAsset);
          } else if (mVal === 'moulu' || mVal === 'ground') {
            setInsetSrc(galleryData.groundAsset);
          }
        }
      }

      /* Listen to Horizon's own variant:update event on document.
         e.detail.resource.id is the new variant ID (string from Horizon). */
      document.addEventListener('variant:update', function (e) {
        var resource = e.detail && e.detail.resource;
        if (!resource) return;
        var vid = parseInt(resource.id, 10);
        if (!vid) return;

        /* Horizon's DOM morph may have removed the inset — re-inject if needed */
        var currentInset = document.querySelector('.cpd-media-inset');
        if (!currentInset) {
          initCpdGallery(false);
          return;
        }

        updateInset(vid);
      });
    }

    /* Boot both features */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initCpdPurchase();
        initCpdGallery();
      });
    } else {
      initCpdPurchase();
      initCpdGallery();
    }
    document.addEventListener('shopify:section:load', function () {
      initCpdPurchase();
      initCpdGallery();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
